import React from 'react'
import { Routes, Route } from "react-router-dom";
import SolicitudesClientes from '../componentes/view/transportes/geopostion';
import Geolocs from '../componentes/view/transportes/geocercas';
import GeocercasTable from '../componentes/view/transportes/geocercasPoligono';


export const TransporteRoute = () => {

  return (
    <Routes>            
      <Route path='/geoloc' element={ <SolicitudesClientes/>}/>
      <Route path='/MGeoloc' element={ <Geolocs/>}/> 
      <Route path='/MantGeoloc' element={ <GeocercasTable/>}/>








    </Routes>
  ) 
}